export default "__VITE_ASSET__DsH0YdFc__"